import React from 'react';

const CreatorPageHeader = ({ kicker, title, description, actions = null, className = '' }) => {
  return (
    <section className={`app-card rounded-[2rem] p-6 sm:p-8 ${className}`}>
      <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
        <div>
          {kicker && <div className="section-kicker mb-4">{kicker}</div>}
          <h1 className="text-2xl sm:text-4xl font-bold text-gray-900">{title}</h1>
          {description && <p className="text-sm text-gray-600 mt-2 max-w-2xl">{description}</p>}
        </div>
        {actions && <div className="flex flex-col sm:flex-row gap-2 sm:gap-3">{actions}</div>}
      </div>
    </section>
  );
};

export default CreatorPageHeader;
